import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  navbarCourses: []
};

export const navbarCoursesSlice = createSlice({
  name: 'navbarCourses',
  initialState,
  reducers: {
    setNavbarCourses: (state, action: PayloadAction<any[]>) => {
      state.navbarCourses = action.payload;
    }
  }
});

export const { setNavbarCourses } = navbarCoursesSlice.actions;

export default navbarCoursesSlice.reducer;
